module.exports = __webpack_public_path__ + "static/media/RailTel-Preview.e4c3aa5e.png";